import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { SubpageHero } from '../components/SubpageHero';

export function ForbiddenPage() {
  return (
    <>
      <SEO 
        title="Adgang nægtet (403)" 
        description="Du har ikke adgang til denne side." 
      />

      <SubpageHero
        badge="Fejl 403"
        title="Adgang til siden er begrænset"
        subtitle="Du har desværre ikke den fornødne adgang til at se det forespurgte indhold."
        icon="fa-solid fa-lock"
        breadcrumbs={[
          { label: "403 Fejl" }
        ]}
        showQuickContact={false}
      >
        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto bg-[#2193BB] hover:bg-[#1b7da0] text-white font-bold px-6 py-3 rounded-xl transition-all cursor-pointer flex items-center justify-center gap-2 shadow-md"
          >
            <i className="fa-solid fa-house" aria-hidden="true" />
            <span>Vend tilbage til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto bg-[#1a2634] border border-[#9D9D9D]/30 hover:bg-[#223245] text-white font-bold px-6 py-3 rounded-xl transition-all cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-envelope text-[#2193BB]" aria-hidden="true" />
            <span>Kontakt os</span>
          </Link>
        </div>
      </SubpageHero>
    </>
  );
}
